import { Ionicons } from "@expo/vector-icons";
import React from "react";
import { Dimensions, Text, View, Platform } from "react-native";
import Modal from "react-native-modal";
import { useSelector } from "react-redux";
import Styles from "../../constants/styles";
import { normalize } from "../../utils/normalize";
import { ModalButtons, DateTimeSelect } from "../all";
import { exportTransactions } from "../../services/job";
import { useMutation } from "@tanstack/react-query";
import moment from "moment";
import * as FileSystem from "expo-file-system";
import * as Sharing from "expo-sharing";

const LocumReportModal = (props) => {
  const { isDoctor } = useSelector((state) => state.user);
  const [startDate, setStartDate] = React.useState(
    moment().subtract(1, "years").toDate()
  );
  const [endDate, setEndDate] = React.useState(moment().toDate());

  const onDownloadTransactions = useMutation(exportTransactions, {
    onError: (error) => {
      alert("Oops! " + error.response.data.message);
    },
    onSuccess: (data) => {
      const fr = new FileReader();
      const filename = `locum-report-${moment(startDate).format("YYYY")}.xlsx`;

      fr.onload = async () => {
        const fileUri = `${FileSystem.documentDirectory}/${filename}`;
        await FileSystem.writeAsStringAsync(fileUri, fr.result.split(",")[1], {
          encoding: FileSystem.EncodingType.Base64,
        });
        saveFile(
          fileUri,
          filename,
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
        Sharing.shareAsync(fileUri);
      };
      fr.readAsDataURL(data.data);
    },
  });

  async function saveFile(uri, filename, mimetype) {
    if (Platform.OS === "android") {
      const permissions =
        await FileSystem.StorageAccessFramework.requestDirectoryPermissionsAsync();

      if (permissions.granted) {
        const base64 = await FileSystem.readAsStringAsync(uri, {
          encoding: FileSystem.EncodingType.Base64,
        });

        await FileSystem.StorageAccessFramework.createFileAsync(
          permissions.directoryUri,
          filename,
          mimetype
        )
          .then(async (uri) => {
            await FileSystem.writeAsStringAsync(uri, base64, {
              encoding: FileSystem.EncodingType.Base64,
            });
          })
          .catch((e) => console.log(e));
      } else {
        Sharing.shareAsync(uri);
      }
    } else {
      Sharing.shareAsync(uri);
    }
  }

  return (
    <Modal
      animationIn={"fadeIn"}
      animationOut={"fadeOut"}
      onBackdropPress={() => props.onHide()}
      {...props}
    >
      <View
        style={{
          width:
            Dimensions.get("window").width > 480
              ? 480
              : Dimensions.get("window").width - 20,
          alignSelf: "center",
          backgroundColor: "white",
          paddingTop: 20,
          borderRadius: 20,
          borderTopLeftRadius: 20,
        }}
      >
        <View style={{ alignItems: "center", marginBottom: 12 }}>
          <Ionicons name="document-text-outline" size={24} color="black" />
        </View>
        <Text
          style={{
            fontWeight: "bold",
            fontSize: normalize(20),
            textAlign: "center",
          }}
        >
          Job Report
        </Text>

        <View
          style={{
            paddingHorizontal: 10,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-around",
              marginTop: 24,
              marginBottom: -14,
            }}
          >
            <Text style={{ fontWeight: "bold", color: "grey", fontSize: 9 }}>
              START DATE
            </Text>
            <Text style={{ fontWeight: "bold", color: "grey", fontSize: 9 }}>
              END DATE
            </Text>
          </View>
          <DateTimeSelect
            beforeToday
            hideTime
            limitDate
            initialData={{
              startDate,
              endDate,
            }}
            onChange={(dates) => {
              setStartDate(dates.startDate);
              setEndDate(dates.endDate);
            }}
          />
          <Text
            style={{
              textAlign: "center",
              marginTop: 12,
              marginBottom: 14,
              marginHorizontal: 24,
            }}
          >
            Please select the date range of job report.
          </Text>
        </View>

        <ModalButtons
          onCancel={() => props.onHide()}
          rightLabel={"Share"}
          onConfirm={() => {
            onDownloadTransactions.mutate({
              data: {
                role: isDoctor ? "doctor" : "clinic",
                startDate: startDate,
                endDate: endDate,
              },
            });
          }}
        />
      </View>
    </Modal>
  );
};

const styles = {
  modalStyle: {
    margin: 0,
    justifyContent: "flex-end",
    ...Styles.shadows,
  },
  modalContainer: {
    backgroundColor: "white",
    height: "60%",
    borderTopLeftRadius: 48,
    borderTopRightRadius: 48,

    marginHorizontal: 0,
    margin: 0,
    ...Styles.shadows,
  },
  calendarContainer: {
    margin: 48,
    marginTop: 12,
  },
  saveButton: {
    alignItems: "center",
    width: Dimensions.get("window").width / 2 - 50,
    backgroundColor: "rgba(0,0,0,0.2)",
  },
  resetButton: {
    alignItems: "center",
    width: Dimensions.get("window").width / 2 - 50,
    backgroundColor: "rgba(0,0,0,0.05)",
  },
};

export default LocumReportModal;
